import React from "react";

function QuoteCard() {
  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #d9d0ca",
        borderRadius: "22px",
        padding: "22px",
        marginBottom: "25px",
      }}
    >
      <div
        style={{
          fontSize: "50px",
          color: "#5a140c",
          lineHeight: "40px",
        }}
      >
        ❝
      </div>

      <div
        style={{
          fontSize: "20px",
          lineHeight: "54px",
          fontWeight: "600",
          color: "#000",
        }}
      >
        We don’t just build
        <br />
        solutions, we build
        <br />
        partnerships.
      </div>
    </div>
  );
}

export default QuoteCard;